// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pqOY8","fullContent":"Card_fullContent__mmIXy","cardHeader":"Card_cardHeader__6DWSx"};